// Helper functions for Google Places API
export interface Suggestion {
  description: string;
  place_id: string;
}

interface GooglePrediction {
  description: string;
  place_id: string;
}

interface GoogleAutocompleteResponse {
  status: string;
  predictions: GooglePrediction[];
}
export interface Location {
  address: string;
  lat: number;
  lng: number;
}

interface GooglePlaceDetailsResponse {
  status: string;
  result?: {
    formatted_address: string;
    geometry: {
      location: {
        lat: number;
        lng: number;
      };
    };
    [key: string]: unknown;
  };
}
export const getAddressFromServer = async (lat: number, lng: number) => {
  const response = await fetch('/api/reverse-geocode', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lat, lng }),
  });
  const data = await response.json();
  return data.address;
};

export async function fetchGooglePlaceSuggestions(
  input: string,
  placesSessionId: string
): Promise<Suggestion[]> {
  const url = `/api/google-places-autocomplete`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ input, placesSessionId }),
  });
  const data: GoogleAutocompleteResponse = await response.json();
  if (data.status === 'OK' && data.predictions) {
    return data.predictions.map((p) => ({
      description: p.description,
      place_id: p.place_id,
    }));
  }
  return [];
}

export async function fetchGooglePlaceDetails(
  placeId: string,
  placesSessionId: string
): Promise<GooglePlaceDetailsResponse['result'] | null> {
  const url = `/api/google-places-details`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ place_id: placeId, placesSessionId }),
  });
  const data: GooglePlaceDetailsResponse = await response.json();
  if (data.status === 'OK' && data.result) {
    return data.result;
  }
  return null;
}
